import { render, staticRenderFns } from "./BaseCheckboxGroup2.vue?vue&type=template&id=af70d574&scoped=true"
import script from "./BaseCheckboxGroup2.vue?vue&type=script&lang=js"
export * from "./BaseCheckboxGroup2.vue?vue&type=script&lang=js"
import style0 from "./BaseCheckboxGroup2.vue?vue&type=style&index=0&id=af70d574&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af70d574",
  null
  
)

export default component.exports